import forEach from 'lodash/forEach';

const SelectFill = {
  /**
   * Create SelectFill component
   * @param {HTMLElement} node
   * @return {Void}
   */
  create(node) {
    this.node = node;
    this.select = node.querySelector('.js-select-fill');

    if (this.select) {
      this.createListeners();
    }
  },

  /**
   * Create event listeners for our select
   * @return {void}
   */
  createListeners() {
    this.select.addEventListener('change', (e) => {
      const select = e.currentTarget;
      const selectedOption = select.querySelector('option:checked');

      if (selectedOption) {
        this.outputOptions(selectedOption.dataset);
      }
    });
  },

  /**
   * Output the data options on the select to the form fields
   * @param {DOMStringMap} data
   * @return {void}
   */
  outputOptions(data) {
    forEach(data, (val, key) => {
      const target = this.node.querySelector(`[data-fill="${key}"]`);

      if (target) {
        target.value = val;
      }
    });
  },
};

export default SelectFill;
